<template>
  <div
    class="create-edit-guid-tour-mask create-edit-guid-tour-mask-pc"
    v-if="renderData.isOpenTour && createRenderType == 'pc'"
    @click="onTourMaskClick"
  >
    <el-tour
      v-if="props.refElList?.length"
      v-model:current="renderData.current"
      v-model="renderData.isOpenTour"
      :class="'create-edit-guid-tour--pc'"
    >
      <template #indicators="{ current, total }">
        <span>{{ current + 1 }} / {{ total }}</span>
      </template>

      <el-tour-step
        :target="props.refElList[0]?.value"
        placement="right"
        :show-arrow="false"
        :show-close="false"
      >
        <div class="create-edit-guid-tour-item" @click.native="onTourMaskClick">
          <div class="cegt-item-step-label">
            {{
              $$tValue("create.step_index", { index: 1 }).replace(/:：/g, "")
            }}
          </div>
          <div class="cegt-item-step-description">
            👈 {{ $$t("create.guid_tour_write_lyrics") }}
          </div>
          <div class="cegt-item-step-next">
            <div class="cegt-item-step-next-button">
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '173px',
                  '--height': '55px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(148, 173, 255, 1)',
                  '--fontColor': '#000',
                  '--fontSize': '20px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
                  '--fontColorHover': '#000',
                }"
                @click="
                  () => {
                    renderData.current = 1
                  }
                "
              >
                <span>{{ $$t("create.continue") }}</span>
              </Button>
            </div>

            <div class="cegt-item-step-skip pt">
              <Button
                :renderStyle="{
                  '--padding': '0 32px',
                  '--width': 'max-content',
                  '--height': '55px',
                  '--borderRadius': '55px',
                  '--background': 'rgba(255, 255, 255, 0.3)',
                  '--fontColor': '#fff',
                  '--fontSize': '20px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.4)',
                  '--fontColorHover': '#fff',
                }"
                @click="onGotIt"
              >
                <span>{{ $$t("create.skip") }}</span>
              </Button>
            </div>
          </div>
        </div>
      </el-tour-step>
      <el-tour-step
        :target="props.refElList[1]?.value"
        :placement="renderData.winWidth < 1300 ? 'left' : 'right'"
        :show-arrow="false"
        :show-close="false"
      >
        <div class="create-edit-guid-tour-item" @click.native="onTourMaskClick">
          <div class="cegt-item-step-label">
            {{
              $$tValue("create.step_index", { index: 2 }).replace(/:：/g, "")
            }}
          </div>
          <div
            v-show="renderData.winWidth < 1300"
            class="cegt-item-step-description"
          >
            Make your music <br />
            idea real 👉
          </div>
          <div
            v-show="renderData.winWidth >= 1300"
            class="cegt-item-step-description"
          >
            👈 {{ $$t("create.guid_tour_edit_idea") }}
          </div>
          <div class="cegt-item-step-next">
            <div class="cegt-item-step-next-button">
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '173px',
                  '--height': '55px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(148, 173, 255, 1)',
                  '--fontColor': '#000',
                  '--fontSize': '20px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
                  '--fontColorHover': '#000',
                }"
                @click="
                  () => {
                    renderData.current = 2
                  }
                "
              >
                <span>{{ $$t("create.continue") }}</span>
              </Button>
            </div>
            <div class="cegt-item-step-skip pt">
              <Button
                :renderStyle="{
                  '--padding': '0 32px',
                  '--width': 'max-content',
                  '--height': '55px',
                  '--borderRadius': '55px',
                  '--background': 'rgba(255, 255, 255, 0.3)',
                  '--fontColor': '#fff',
                  '--fontSize': '20px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.4)',
                  '--fontColorHover': '#fff',
                }"
                @click="onGotIt"
              >
                <span>{{ $$t("create.skip") }}</span>
              </Button>
            </div>
          </div>
        </div>
      </el-tour-step>
      <el-tour-step
        :target="props.refElList[2]?.value"
        placement="right-end"
        :show-arrow="false"
        :show-close="false"
      >
        <div
          class="create-edit-guid-tour-item create-edit-guid-tour-item-pc3"
          @click.native="onTourMaskClick"
        >
          <div class="cegt-item-step-label">
            {{
              $$tValue("create.step_index", { index: 3 }).replace(/:：/g, "")
            }}
          </div>
          <div class="cegt-item-step-description">
            <span
              >👈 {{ $$t("create.guid_tour_create_song") }}
              <span class="cegt-item-step-lm">
                <Button
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '173px',
                    '--height': '55px',
                    '--borderRadius': '48px',
                    '--background': 'rgba(148, 173, 255, 1)',
                    '--fontColor': '#000',
                    '--fontSize': '20px',
                    '--fontWeight': '500',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
                    '--fontColorHover': '#000',
                  }"
                  @click="onGotIt"
                >
                  <span>{{ $$t("create.got_it") }}</span>
                </Button>
              </span>
            </span>
          </div>
          <div class="cegt-item-step-next"></div>
        </div>
      </el-tour-step>
    </el-tour>
  </div>
  <div
    class="create-edit-guid-tour-mask create-edit-guid-tour-mask-mobile"
    v-if="renderData.isOpenTour && createRenderType == 'mobile'"
    @click="onTourMaskClick"
  >
    <el-tour
      v-if="props.refElList?.length"
      v-model:current="renderData.current"
      v-model="renderData.isOpenTour"
      :class="'create-edit-guid-tour--mobile'"
      :mask="{
        style: {},
        color: 'rgba(255, 255, 255, 1)',
      }"
    >
      <!-- <template v-slot:indicators=="{current, total}">
        <div>
          
        </div>
      </template> -->
      <el-tour-step
        :target="props.refElList[0]?.value"
        placement="bottom"
        :show-arrow="true"
        :show-close="false"
      >
        <div class="create-edit-guid-tour-item" @click.native="onTourMaskClick">
          <div class="create-edit-guid-tour-item-main">
            <div class="cegt-item-step-description">
              👆 {{ $$t("create.guid_tour_write_lyrics") }}
            </div>
            <div class="cegt-item-step-next">
              <div class="cegt-item-step-label">1/3</div>
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100px',
                  '--height': '40px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(255, 255, 255, 1)',
                  '--fontColor': '#000',
                  '--fontSize': '14px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.8)',
                  '--fontColorHover': '#000',
                }"
                @click="
                  () => {
                    renderData.current = 1
                  }
                "
              >
                <span>{{ $$t("create.continue") }}</span>
              </Button>
            </div>
          </div>
          <div class="create-edit-guid-tour-item-skip">
            <Button
              :renderStyle="{
                '--padding': '0 10px',
                '--width': 'max-content',
                '--height': '32px',
                '--borderRadius': '32px',
                '--background': 'rgba(255, 255, 255, 0.3)',
                '--fontColor': '#fff',
                '--fontSize': '14px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.4)',
                '--fontColorHover': '#fff',
              }"
              @click="onGotIt"
            >
              <span>{{ $$t("create.skip") }}</span>
            </Button>
          </div>
        </div>
      </el-tour-step>
      <el-tour-step
        :target="props.refElList[1]?.value"
        placement="top"
        :show-arrow="true"
        :show-close="false"
      >
        <div class="create-edit-guid-tour-item" @click.native="onTourMaskClick">
          <div class="create-edit-guid-tour-item-main">
            <div class="cegt-item-step-next t">
              <div class="cegt-item-step-label">2/3</div>
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100px',
                  '--height': '40px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(255, 255, 255, 1)',
                  '--fontColor': '#000',
                  '--fontSize': '14px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.8)',
                  '--fontColorHover': '#000',
                }"
                @click="
                  () => {
                    renderData.current = 2
                  }
                "
              >
                <span>{{ $$t("create.continue") }}</span>
              </Button>
            </div>
            <div class="cegt-item-step-description b">
              {{ $$t("create.guid_tour_edit_idea") }} 👇
            </div>
          </div>
          <div class="create-edit-guid-tour-item-skip pt">
            <Button
              :renderStyle="{
                '--padding': '0 10px',

                '--width': 'max-content',
                '--height': '32px',
                '--borderRadius': '32px',
                '--background': 'rgba(255, 255, 255, 0.3)',
                '--fontColor': '#fff',
                '--fontSize': '14px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.4)',
                '--fontColorHover': '#fff',
              }"
              @click="onGotIt"
            >
              <span>{{ $$t("create.skip") }}</span>
            </Button>
          </div>
        </div>
      </el-tour-step>
      <el-tour-step
        :target="props.refElList[2]?.value"
        placement="top"
        :show-arrow="true"
        :show-close="false"
      >
        <div class="create-edit-guid-tour-item" @click.native="onTourMaskClick">
          <div class="create-edit-guid-tour-item-main">
            <div class="cegt-item-step-next t">
              <div class="cegt-item-step-label">3/3</div>
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100px',
                  '--height': '40px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(255, 255, 255, 1)',
                  '--fontColor': '#000',
                  '--fontSize': '14px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.8)',
                  '--fontColorHover': '#000',
                }"
                @click="onGotIt"
              >
                <span>{{ $$t("create.got_it") }}</span>
              </Button>
            </div>
            <div class="cegt-item-step-description b">
              {{ $$t("create.guid_tour_create_song") }} 👇
            </div>
          </div>
        </div>
      </el-tour-step>
    </el-tour>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { storeToRefs } from "pinia"

import { $$language, $$t, $$tValue } from "@/i18n/i18n.js"

import Button from "@/components/basic/button/Button.vue"
import useUserDataStore from "@/store/userDataStore.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"

const userDataStore = useUserDataStore()
const createLayoutStore = useCreateLayoutStore()
const {
  createRenderType,
  createEditGuidTourVisible,
  create_createEditOpenState,
  createEditMode,
  createEditGuidTourCurStep,
  createEditGuidTourControlVisible,
} = storeToRefs(createLayoutStore)

const props = defineProps({
  refElList: {
    type: Array,
    default: () => [],
  },
})
const emits = defineEmits([])
const renderData = reactive({
  isOpenTour: false,
  current: 0,
  winWidth: window.innerWidth,
})

const initTour = () => {
  setTimeout(() => {
    if (createRenderType.value == "pc") {
      renderData.isOpenTour =
        createEditGuidTourVisible.value &&
        createEditGuidTourControlVisible.value &&
        createEditMode.value == "hard"
    } else {
      renderData.isOpenTour =
        create_createEditOpenState.value == "max" &&
        createEditMode.value == "hard" &&
        createEditGuidTourVisible.value &&
        createEditGuidTourControlVisible.value
    }
  }, 500)
}

const onTourMaskClick = () => {
  if (renderData.current < 2) {
    renderData.current = renderData.current + 1
  } else {
    onGotIt()
  }
}

const onGotIt = () => {
  const globalProperties =
    (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties

  renderData.current = 0
  renderData.isOpenTour = false
  // createLayoutStore.setCreateEditGuidTourVisible(false);

  globalProperties?.logClickEvent("create_advanced_mode_guide_finish", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
}
watch(
  () => {
    return createEditGuidTourVisible.value
  },
  () => {
    initTour()
  }
)

watch(
  () => {
    return createEditGuidTourControlVisible.value
  },
  () => {
    initTour()
  }
)

watch(
  () => {
    return create_createEditOpenState.value
  },
  () => {
    initTour()
  }
)
watch(
  () => {
    return createEditMode.value
  },
  () => {
    initTour()
  }
)
watch(
  () => {
    return createEditGuidTourCurStep.value
  },
  () => {
    renderData.current = createEditGuidTourCurStep.value
  }
)

watch(
  () => {
    return renderData.current
  },
  () => {
    createLayoutStore.setCreateEditGuidTourCurStep(renderData.current)
  }
)
watch(
  () => {
    return renderData.isOpenTour
  },
  () => {
    createLayoutStore.setCreateEditGuidTourVisible(renderData.isOpenTour)
  }
)
const onResize = () => {
  renderData.winWidth = window.innerWidth
}
onMounted(() => {
  initTour()
  renderData.resizeObserver = new ResizeObserver(onResize)?.observe(
    document.body
  )
})
onUnmounted(() => {
  renderData.resizeObserver?.disconnect()
})
</script>
<style lang="scss">
.el-tour__mask {
  z-index: 10 !important;
}
.el-tour__content {
  z-index: 10 !important;
}
.create-edit-guid-tour-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.el-tour.create-edit-guid-tour--pc {
  .el-tour__hollow {
    fill: rgba(0, 0, 0, 0.8) !important;
    stroke: #94adff !important;
    stroke-width: 0;
    stroke-linecap: round;
    stroke-linejoin: round;
    pointer-events: none !important;
  }

  .el-tour__content {
    background: transparent;
    padding: 0;
    width: max-content !important;
    &[data-side="right"] {
      transform: translateX(12px);
    }
    &[data-side="left"] {
      transform: translateX(-12px);
    }
    &[data-side="top"] {
      transform: translateY(12px);
    }
    &[data-side="bottom"] {
      transform: translateX(12px);
    }
  }
  .el-tour__header {
    display: none;
  }
  .el-tour__footer {
    display: none;
  }
  .create-edit-guid-tour-item {
    .cegt-item-step-label {
      line-height: 56px;
      font-family: HarmonyOS Sans SC;
      font-size: 40px;
      font-weight: bold;
      background: linear-gradient(111deg, #4fdeff 0%, #e675ff 100%);
      color: transparent;
      background-clip: text;
    }
    .cegt-item-step-description {
      font-family: HarmonyOS Sans SC;
      font-size: 40px;
      line-height: 56px;
      font-weight: bold;
      color: #ffffff;
      padding-top: 24px;
      > span {
        display: inline-block;
      }
      .cegt-item-step-lm {
        margin: 0 0 0 8px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .cegt-item-step-next {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .cegt-item-step-skip {
      margin-left: 12px;
    }
    &.create-edit-guid-tour-item-pc3 {
      transform: translateY(20px);
    }
  }
}
.el-tour.create-edit-guid-tour--mobile {
  .el-tour__hollow {
    fill: rgba(0, 0, 0, 0.8) !important;
    stroke: #94adff !important;
    margin: -10px !important;
    stroke-width: 0;
    stroke-linecap: round;
    pointer-events: none !important;
    stroke-linejoin: round;
  }
  .el-tour__arrow {
    background: #94adff;
  }

  .el-tour__content {
    background: #94adff;
    border-radius: 12px;
    padding: 0;
    width: max-content !important;
    max-width: max-content !important;
  }
  .el-tour__header {
    display: none;
  }
  .el-tour__footer {
    display: none;
  }
  .create-edit-guid-tour-item {
    position: relative;
    padding: 20px;
    .cegt-item-step-label {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 40px;
      color: #ffffff;
      flex: 1 1 0;
      margin-right: 12px;
    }
    .cegt-item-step-description {
      font-family: HarmonyOS Sans SC;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      color: #ffffff;
      max-width: 280px;
      &.b {
        margin-top: 12px;
      }
    }
    .cegt-item-step-next {
      margin-top: 12px;
      display: flex;
      width: 100%;
      &.t {
        margin-top: 0;
      }
    }
    .create-edit-guid-tour-item-skip {
      position: absolute;
      bottom: -52px;
      left: 50%;
      transform: translateX(-50%);
      font-family: HarmonyOS Sans SC;
      &.pt {
        bottom: unset;
        top: -52px;
      }
    }
  }
}
</style>
